/**
 * @generated SignedSource<<19df8827a77d347c8da36c2e96c93904>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NotificationsWatchStreamsRowQuery$variables = {};
export type NotificationsWatchStreamsRowQuery$data = {
  readonly viewer: {
    readonly settings: {
      readonly automaticallyWatchNotestreams: boolean | null;
    };
  };
};
export type NotificationsWatchStreamsRowQuery = {
  response: NotificationsWatchStreamsRowQuery$data;
  variables: NotificationsWatchStreamsRowQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "UserSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "automaticallyWatchNotestreams",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsWatchStreamsRowQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NotificationsWatchStreamsRowQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "88bf23bcf84e34190d13285d1372a2bb",
    "id": null,
    "metadata": {},
    "name": "NotificationsWatchStreamsRowQuery",
    "operationKind": "query",
    "text": "query NotificationsWatchStreamsRowQuery {\n  viewer {\n    settings {\n      automaticallyWatchNotestreams\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd2de4beacd592149728b0d09249b75b";

export default node;
